import { Installation } from "@/model/data/Installation";
import { LicenseData } from "@/model/data/License/LicenseData";
import { LicenseModuleSummary } from "@/model/data/License/LicenseModuleSummary";

export class LicenseState {
    licenseModules: LicenseData = new LicenseData();

    licensesDataSummary: [] = [];
    licensesDataSummaryLocal: LicenseModuleSummary[] = [];

    installations: Installation[] = [];
    localInstallations: Installation[] = [];

    constructor() {}
}

export default new LicenseState();
